/** Read the renderer context; throws if used outside a BuilderEngine provider. */
import { useContext } from 'react'
import { RendererContext } from './rendererContext'
import type { RendererContextValue } from './rendererContext'

export function useRendererContext(): RendererContextValue {
  const value = useContext(RendererContext)
  if (!value) {
    throw new Error('useRendererContext must be used within a BuilderEngine provider')
  }
  return value
}
